import request from '@/utils/request';

// 获取AI质检筛选项/枚举/权限可见操作
export async function getQwAiQualityOptionsApi(params) {
  const response = await request({
    url: '/admin/qw_ai_quality/options',
    method: 'get',
    params: params,
  });
  return response.data;
}

// 获取AI质检列表
export async function getQwAiQualityListApi(data) {
  const response = await request({
    url: '/admin/qw_ai_quality/list',
    method: 'post',
    data: data,
  });
  return response.data;
}

// 获取AI质检详情
export async function getQwAiQualityDetailApi(params) {
  const response = await request({
    url: '/admin/qw_ai_quality/detail',
    method: 'get',
    params: params,
  });
  return response.data;
}

// 确认质检结果（待质检 -> 已确认）
export async function confirmQwAiQualityApi(data) {
  const response = await request({
    url: '/admin/qw_ai_quality/confirm',
    method: 'post',
    data: data,
  });
  return response.data;
}

// 标记仅提醒（待质检 -> 仅提醒）
export async function remindOnlyQwAiQualityApi(data) {
  const response = await request({
    url: '/admin/qw_ai_quality/remind_only',
    method: 'post',
    data: data,
  });
  return response.data;
}

// 标记误报（待质检 -> 误报）
export async function falseHitQwAiQualityApi(data) {
  const response = await request({
    url: '/admin/qw_ai_quality/false_hit',
    method: 'post',
    data: data,
  });
  return response.data;
}

// 标记无需处理（待质检 -> 无需处理）
export async function noActionQwAiQualityApi(data) {
  const response = await request({
    url: '/admin/qw_ai_quality/no_action',
    method: 'post',
    data: data,
  });
  return response.data;
}

// 提交申诉（已确认/申诉驳回 -> 申诉处理中）
export async function appealQwAiQualityApi(data) {
  const response = await request({
    url: '/admin/qw_ai_quality/appeal',
    method: 'post',
    data: data,
  });
  return response.data;
}

// 申诉审核通过（申诉处理中 -> 申诉通过）
export async function appealPassQwAiQualityApi(data) {
  const response = await request({
    url: '/admin/qw_ai_quality/appeal_pass',
    method: 'post',
    data: data,
  });
  return response.data;
}

// 申诉审核驳回（申诉处理中 -> 申诉驳回）
export async function appealRejectQwAiQualityApi(data) {
  const response = await request({
    url: '/admin/qw_ai_quality/appeal_reject',
    method: 'post',
    data: data,
  });
  return response.data;
}

// 批量确认
export async function batchConfirmQwAiQualityApi(data) {
  const response = await request({
    url: '/admin/qw_ai_quality/batch_confirm',
    method: 'post',
    data: data,
  });
  return response.data;
}

// 批量标记仅提醒
export async function batchRemindOnlyQwAiQualityApi(data) {
  const response = await request({
    url: '/admin/qw_ai_quality/batch_remind_only',
    method: 'post',
    data: data,
  });
  return response.data;
}

// 批量标记误报
export async function batchFalseHitQwAiQualityApi(data) {
  const response = await request({
    url: '/admin/qw_ai_quality/batch_false_hit',
    method: 'post',
    data: data,
  });
  return response.data;
}

// 批量标记无需处理
export async function batchNoActionQwAiQualityApi(data) {
  const response = await request({
    url: '/admin/qw_ai_quality/batch_no_action',
    method: 'post',
    data: data,
  });
  return response.data;
}

// 批量申诉审核通过
export async function batchAppealPassQwAiQualityApi(data) {
  const response = await request({
    url: '/admin/qw_ai_quality/batch_appeal_pass',
    method: 'post',
    data: data,
  });
  return response.data;
}

// 批量申诉审核驳回
export async function batchAppealRejectQwAiQualityApi(data) {
  const response = await request({
    url: '/admin/qw_ai_quality/batch_appeal_reject',
    method: 'post',
    data: data,
  });
  return response.data;
}

// 按当前映射规则刷新负责客服/城市
export async function refreshOwnerQwAiQualityApi(data) {
  const response = await request({
    url: '/admin/qw_ai_quality/refresh_owner',
    method: 'post',
    data: data,
  });
  return response.data;
}

// 看板汇总指标
export async function getQwAiQualityDashboardSummaryApi(data) {
  const response = await request({
    url: '/admin/qw_ai_quality/dashboard/summary',
    method: 'post',
    data: data,
  });
  return response.data;
}

// 看板标签分布
export async function getQwAiQualityLabelDistributionApi(data) {
  const response = await request({
    url: '/admin/qw_ai_quality/dashboard/label_distribution',
    method: 'post',
    data: data,
  });
  return response.data;
}

// 看板客服问题排行
export async function getQwAiQualityCustomerServiceRankApi(data) {
  const response = await request({
    url: '/admin/qw_ai_quality/dashboard/customer_service_rank',
    method: 'post',
    data: data,
  });
  return response.data;
}

// 看板质检数量排行
export async function getQwAiQualityCountRankApi(data) {
  const response = await request({
    url: '/admin/qw_ai_quality/dashboard/quality_count_rank',
    method: 'post',
    data: data,
  });
  return response.data;
}

// 获取企微报警策略配置
export async function getQwAiQualityWecomPolicyApi() {
  const response = await request({
    url: '/admin/qw_ai_quality/wecom_policy',
    method: 'get',
  });
  return response.data;
}

// 保存企微报警策略配置
export async function saveQwAiQualityWecomPolicyApi(data) {
  const response = await request({
    url: '/admin/qw_ai_quality/wecom_policy/save',
    method: 'post',
    data: data,
  });
  return response.data;
}

// 获取飞书预警策略配置
export async function getQwAiQualityFeishuAlertPolicyApi() {
  const response = await request({
    url: '/admin/qw_ai_quality/feishu_alert_policy',
    method: 'get',
  });
  return response.data;
}

// 保存飞书预警策略配置
export async function saveQwAiQualityFeishuAlertPolicyApi(data) {
  const response = await request({
    url: '/admin/qw_ai_quality/feishu_alert_policy/save',
    method: 'post',
    data: data,
  });
  return response.data;
}

// 获取时效质检规则配置
export async function getQwAiQualityTimelinessRuleApi() {
  const response = await request({
    url: '/admin/qw_ai_quality/timeliness_rule',
    method: 'get',
  });
  return response.data;
}

// 保存时效质检规则配置
export async function saveQwAiQualityTimelinessRuleApi(data) {
  const response = await request({
    url: '/admin/qw_ai_quality/timeliness_rule/save',
    method: 'post',
    data: data,
  });
  return response.data;
}

// 获取现有运营后台主游戏选项
export async function getQwAiQualityMainGameOptionsApi() {
  const response = await request({
    url: '/admin/get_same_yun_game_tree',
    method: 'get',
  });
  return response.data;
}
